var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF6F7",
    stroke: "#C72C3F",
    strokeDasharray: "4 2",
    d: "M44 1a43 43 0 1 1 0 86 43 43 0 0 1 0-86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C72C3F",
    fillRule: "evenodd",
    d: "M54.895 38.157C53.852 33.777 50.691 28 43.502 28c-5.5 0-8.198 2.472-9.493 4.549-.498.8-.875 1.67-1.119 2.581-3.447.984-7.887 3.776-7.887 9.687a10.031 10.031 0 0 0 6.6 9.686 17.028 17.028 0 0 0 6.013 1.245h.84v-2.523h-.84s-10.09 0-10.09-8.408c0-6.727 7.567-7.568 7.567-7.568s0-6.727 8.409-6.727c8.408 0 9.249 10.09 9.249 10.09a6.25 6.25 0 0 1 .698 0c1.681 0 6.029.539 6.029 5.886 0 6.727-10.09 6.727-10.09 6.727h-1.682v2.523h1.681c4.364 0 12.613-1.934 12.613-9.25 0-5.482-3.565-7.853-7.105-8.34Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C72C3F",
    fillRule: "evenodd",
    d: "M47.832 44.623a1.261 1.261 0 0 0 1.858-1.681l-5.044-5.466a2.413 2.413 0 0 0-2.456 0l-5.465 5.575a1.261 1.261 0 1 0 1.8 1.766l3.304-3.364v17.658a1.261 1.261 0 1 0 2.522 0V40.84l3.481 3.783Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.a8604157871f64126ebe55ca418bfd0f.svg";
export { ForwardRef as ReactComponent };